import { render } from "./UserDropDownComp.vue?vue&type=template&id=6833c55d&scoped=true"
import script from "./UserDropDownComp.vue?vue&type=script&lang=js"
export * from "./UserDropDownComp.vue?vue&type=script&lang=js"

import "./UserDropDownComp.vue?vue&type=style&index=0&id=6833c55d&scoped=true&lang=css"

import exportComponent from "D:\\deploy\\ths\\evangelism_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6833c55d"]])

export default __exports__